import React, { useEffect, useState } from "react";
import './payment.css';
import { PriceDetails } from "./paySummary";
import { PaymentContext } from "./PaymentContext";
import { useNavigate } from "react-router";
import PaymentCard from "./PaymentCard";


export default function PaymentProceed(){
    const [err,setErr] = useState("");
    const [card, setCard] = useState("");
    const [expiry, setExpiry] = useState("");
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [amount, setAmount] = useState(0);
    
    return (
    <>
        <p className="warning">* Developer project for educational purpose do not enter any confidential details</p>
        <h3 style={{marginLeft:"10px"}}>Billing Section</h3>
        <div className="pay-flex">
            {!isOpen && <PriceDetails open={setIsOpen} amount={amount} setAmount={setAmount}/>}
        </div>
        {isOpen && <PaymentCard open={setIsOpen} amount={amount}/>}
    </>
    )
    
}


